import { createAction } from "typesafe-actions";

import {
    TABLE_SELECTION_CLEAR_TABLE_ACTION,
    TABLE_SELECTION_CREATE_TABLE_ACTION,
    TABLE_SELECTION_SET_SELECTED_ROW_ACTION,
    TABLE_SELECTION_SET_SELECTED_ROWS_ACTION,
    TABLE_SELECTION_TOGGLE_ROWS_ACTION,
    TABLE_SELECTION_UNSET_SELECTED_ROW_ACTION,
    TABLE_SELECTION_UNSET_SELECTED_ROWS_ACTION,
} from "app/action_types/table_actions";
import type { TableActionData } from "app/reducers/_reducers/tableSelection.reducer";

export const createTableSelection = createAction(TABLE_SELECTION_CREATE_TABLE_ACTION)<
    Omit<TableActionData, "records">
>();
export const clearTableSelection = createAction(TABLE_SELECTION_CLEAR_TABLE_ACTION)<
    Omit<TableActionData, "records" | "selectKey">
>();
export const toggleSelectedRows = createAction(TABLE_SELECTION_TOGGLE_ROWS_ACTION)<TableActionData>();
export const setSelectedRows = createAction(TABLE_SELECTION_SET_SELECTED_ROWS_ACTION)<TableActionData>();
export const setSelectedRow = createAction(TABLE_SELECTION_SET_SELECTED_ROW_ACTION)<Omit<TableActionData, "records">>();
export const unsetSelectedRows = createAction(TABLE_SELECTION_UNSET_SELECTED_ROWS_ACTION)<TableActionData>();
export const unsetSelectedRow = createAction(TABLE_SELECTION_UNSET_SELECTED_ROW_ACTION)<
    Omit<TableActionData, "records">
>();

export const tableActionsCreator = <T = object>(tableKey: string | number, selectKey: string | number) => {
    return {
        toggleRows: (records: T[]) => toggleSelectedRows({ selectKey, tableKey, records }),
        selectRows: (records: T[]) => setSelectedRows({ selectKey, tableKey, records }),
        unselectRows: (records: T[]) => unsetSelectedRows({ selectKey, tableKey, records }),
        selectRow: (record: T) => setSelectedRow({ selectKey, tableKey, record }),
        unselectRow: (record: T) => setSelectedRow({ selectKey, tableKey, record }),
        clearAllSelectedRows: () => clearTableSelection({ tableKey }),
    };
};
